/**
 * Data categories: sets of fields that need their own permission on top of
 * the module permission of the screen that shows them. Read by the API
 * (projection of responses, export refusal) and by the web (which fields a
 * form shows and sends).
 *
 * - payroll: salary, allowances, CNSS number, IFU and bank account of an
 *   employee, and per-employee pay amounts (api services/hr/employee-pay-fields.ts).
 * - personal: an employee's address, phone and e-mail.
 * - health: the reason of a sick or maternity leave.
 */
import { hasPermission } from "../services/permission-matcher.js";
export const DATA_CATEGORIES = {
    payroll: { permission: "payroll:read", label: "Paie" },
    personal: { permission: "data:personal", label: "Données personnelles" },
    health: { permission: "data:health", label: "Données de santé" },
};
/** Does a session holding `permissions` see the fields of `category`? */
export function holdsDataCategory(permissions, category) {
    return hasPermission(permissions ?? [], DATA_CATEGORIES[category].permission);
}
/** Employee fields of the personal category. */
export const EMPLOYEE_PERSONAL_FIELDS = ["email", "phone", "address"];
/** Leave types whose reason belongs to the health category. */
export const HEALTH_LEAVE_TYPES = ["MALADIE", "MATERNITE"];
//# sourceMappingURL=data-categories.js.map